import DesignHubAPICall from "src/service/DesignHubAPICall";
import BaseRepository from "src/repository/BaseRepository";


class DesignHubRepository extends BaseRepository {
    registerUser = async (params) => {
        return await new DesignHubAPICall().registerUser(params);
    };
    getCountryList = async () => {
        return await new DesignHubAPICall().getCountryList();
    };
    getCrossReferencePart = async (params) => {
        return await new DesignHubAPICall().getCrossReferenceParts(params.ERPMFRPartNumber)
    }

}

export default DesignHubRepository;